import * as actionTypes from "../constants/actionTypes";
import * as types from "../constants/componentTypes";
import * as orderBy from "../constants/orderBy";
import * as config from "../constants/config";
import * as modelHelper from "../helpers/modelHelper";

const initialState = {
    activeOrder: null,
    printData: null,
    tmcData: null,
    infoData: null,
    orderList: [],
    sortingCriterion: orderBy.CREATED,
    sortingAsc: false,
    filter: null,
    offset: config.MAX_ORDERS_LIMIT
};

/**
 * Structure of object from myOrders store:
 * - activeOrder {object}
 * - printData {Object}
 * - tmcData {Object}
 * - infoData {Object}
 * - orderList {array}
 * - sortingCriterion {string}
 * - sortingAsc {boolean}
 * - filter {string}
 * - offset {Number}
 */
export const myOrdersTabReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MY_ORDERS_TAB_INIT:
            return initialState;
        case actionTypes.MY_ORDERS_SAVE_DATA:
            return {
                ...state,
                orderList: modelHelper.mapOrdersToObjects(action.payload.myOrderList)
            };
        case actionTypes.MY_ORDERS_SAVE_DATA_WITH_OFFSET:
            return {
                ...state,
                orderList: state.orderList.concat(modelHelper.mapOrdersToObjects(action.payload.myOrderList))
            };
        case actionTypes.MY_ORDERS_SAVE_DETAIL:
            if (action.payload.order === null) {
                return {
                    ...state,
                    activeOrder: null,
                    printData: null,
                    tmcData: null,
                    infoData: null
                };
            }

            return {
                ...state,
                activeOrder: modelHelper.mapPlainOrderDataToObject(action.payload.order, action.payload.database),
                printData: action.payload.printData ? modelHelper.formatPrintData(action.payload.printData) : null,
                tmcData: action.payload.tmcData ? action.payload.tmcData : null,
                infoData: action.payload.infoData ? action.payload.infoData : null
            };
        case actionTypes.MY_ORDERS_SAVE_SORTING:
            return {
                ...state,
                sortingCriterion: action.payload.criterion,
                sortingAsc: action.payload.asc
            };
        case actionTypes.SAVE_ORDER_STATUS:
            let newOrderList = [];

            state.orderList.forEach((order) => {
                if (order.identifier === action.payload.orderIdentifier) {
                    newOrderList.push(order.updateOrderStatus(action.payload.status, action.payload.updated));
                } else {
                    newOrderList.push(order.clone());
                }
            });

            return {
                ...state,
                orderList: newOrderList
            };
        case actionTypes.MY_ORDERS_SAVE_FILTER:
            return {
                ...state,
                filter: action.payload.filter
            };
        case actionTypes.MY_ORDERS_CHANGE_OFFSET:
            return {
                ...state,
                offset: action.payload.offset
            };
        case actionTypes.SAVE_MANUAL_FORMULA_MY_ORDERS:
            if (state.activeOrder === null || state.activeOrder.formula === null) {
                return state;
            }

            return {
                ...state,
                activeOrder: state.activeOrder.updateManualColorantList(
                    modelHelper.mapManualColorantsToObjects(
                        state.activeOrder.formula.realColorantList,
                        action.payload.formula
                    )
                )
            };
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE:
        case actionTypes.CLOSE_ALL_TABS:
            let tab;
            for (tab of action.payload.newTabList) {
                if (tab.type === types.MY_ORDERS_TAB) {
                    return state;
                }
            }

            return initialState;
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
            return initialState;

        case actionTypes.MY_ORDERS_SAVE_PACKAGE_PREVIEW_IMAGE:
            if (state.activeOrder === null) {
                return state;
            }

            return {
                ...state,
                activeOrder: state.activeOrder.updateImageId(action.payload.imageId)
            };
        default:
            return state;
    }
};
